module.exports = __webpack_public_path__ + "resources/img/sp_remoteview_m.7254d315b9a5c7a0e9db7955f3367813.png";